import axios from "axios";
import { getField, updateField } from "vuex-map-fields";
import i18n from "@/i18n";
import Vue from "vue";

export default {
    namespaced: true,
    state: {
        isLoading: false,
        smsTemplates: [],
        smsTemplatePlaceholders: null
    },
    getters: {
        getField, //vuex-map-fields
    },
    mutations: {
        updateField, //vuex-map-fields
        addToState(state, data) {
            let object = state.smsTemplates;
            object.unshift(data);
            Vue.set(state, "smsTemplates", object);
        },
        removeFromState(state, id) {
            let items = [];
            Object.entries(state.smsTemplates).forEach((item) => {
                if (Number(item[1].id) != Number(id)) {
                    items.push(item[1]);
                }
            });
            Vue.set(state, "smsTemplates", items);
        },
        updateInState(state, data) {
            let existsAtIndex = state.smsTemplates.findIndex(u => u.id === data.id)
            if (existsAtIndex !== -1) {
                state.smsTemplates[existsAtIndex] = data
            }
            //Clone the array to trigger a UI update
            state.smsTemplates = [...state.smsTemplates]
        }
    },
    actions: {
        async applyTemplateForCustomer({ commit, state, dispatch }, payload) {
            updateField(state, { path: "isLoading", value: true });
            return await axios
                .post(this._vm.$apiURL + "/sms-templates/"+payload.template_id+"/apply-for-customer", {
                    customer_id:payload.customer_id,
                    template_id: payload.template_id
                })
                .then((response) => {
                    if (response.data && response.data.data) {
                        return response.data.data;
                    } else {
                        throw "Unknown error";
                    }
                })
                .catch((error) => {
                    dispatch("common/showError", { error: error }, { root: true });
                })
                .finally(() => {
                    updateField(state, { path: "isLoading", value: false });
                });
        },
        async applyTemplateForOrder({ commit, state, dispatch }, payload) {
            updateField(state, { path: "isLoading", value: true });
            return await axios
                .post(this._vm.$apiURL + "/sms-templates/"+payload.template_id+"/apply-for-order", { order_id:payload.order_id })
                .then((response) => {
                    if (response.data && response.data.data) {
                        return response.data.data;
                    } else {
                        throw "Unknown error";
                    }
                })
                .catch((error) => {
                    dispatch("common/showError", { error: error }, { root: true });
                })
                .finally(() => {
                    updateField(state, { path: "isLoading", value: false });
                });
        },
        async store({ commit, state, dispatch }, payload) {
            updateField(state, { path: "isLoading", value: true });
            return await axios
                .post(this._vm.$apiURL + "/sms-templates", payload)
                .then((response) => {
                    if (response.data && response.data.new && response.data.new.id > 0) {
                        this._vm.$inform(this._vm.i18n.t("common.success_add"));
                        commit("addToState", response.data.new);
                        return response.data.new.id;
                    } else {
                        throw "Unknown error";
                    }
                })
                .catch((error) => {
                    dispatch("common/showError", { error: error }, { root: true });
                })
                .finally(() => {
                    updateField(state, { path: "isLoading", value: false });
                });
        },
        remove({ commit, state, dispatch }, payload) {
            this._vm
                .$confirm({
                    title: this._vm.i18n.t("common.confirm"),
                    text: this._vm.i18n.t("common.confirm_remove"),
                    cancelText: this._vm.i18n.t("common.no"),
                    acceptText: this._vm.i18n.t("common.yes"),
                })
                .then((y) => {
                    return axios
                        .delete(this._vm.$apiURL + "/sms-templates/" + payload.id)
                        .then((response) => {
                            if (response.data.status === "success") {
                                commit("removeFromState", payload.id);
                                this._vm.$inform(this._vm.i18n.t("common.success_remove"));
                            }
                        })
                        .catch((error) => {
                            dispatch("common/showError", { error: error }, { root: true });
                        });
                })
                .catch((n) => {});
        },
        async update({ commit, state, dispatch }, payload) {
            updateField(state, { path: "savingInProgress", value: true });
            return await axios
                .put(this._vm.$apiURL + "/sms-templates/" + payload.id, payload)
                .then((response) => {
                    if(response.data && response.data.status === "success" && response.data.updated) {
                        this._vm.$inform(this._vm.i18n.t("common.operation_success"));
                        commit('updateInState', response.data.updated)
                    }
                    return response.data.updated;
                })
                .catch((error) => {
                    dispatch("common/showError", { error: error }, { root: true });
                    return false;
                })
                .finally(() => {
                    updateField(state, { path: "savingInProgress", value: false });
                });
        },
        async test({ commit, state, dispatch }, payload){
            updateField(state, { path: "isLoading", value: true });
            return axios.post(this._vm.$apiURL + "/sms-templates/test", payload)
                .then((response) => {
                    // if(response.data && response.data.status === "success") {
                    //     this._vm.$inform(this._vm.i18n.t("common.operation_success"));
                    // }
                    return response.data.data;
                })
                .catch((error) => {
                    dispatch("common/showError", { error: error }, { root: true });
                    return false;
                })
                .finally(() => {
                    updateField(state, { path: "isLoading", value: false });
                });
        },
        async get({ commit, state, dispatch }, payload){
            updateField(state, { path: "isLoading", value: true });
            return axios
                .get(this._vm.$apiURL + "/sms-templates")
                .then((response) => {
                    updateField(state, { path: "smsTemplates", value: response.data.data });
                })
                .catch((error) => {
                    dispatch("common/showError", { error: error }, { root: true });
                })
                .finally(() => {
                    updateField(state, { path: "isLoading", value: false });
                });
        }
    },
}
